import { render, staticRenderFns } from "./supplierView.vue?vue&type=template&id=a366eab4&scoped=true&"
import script from "./supplierView.vue?vue&type=script&lang=js&"
export * from "./supplierView.vue?vue&type=script&lang=js&"
import style0 from "./supplierView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./supplierView.vue?vue&type=style&index=1&id=a366eab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a366eab4",
  null
  
)

export default component.exports